export const normalizeRole = (role: string | null | undefined): string =>
  (role ?? '').trim().toLowerCase();

export const isAdmin = (role: string | null | undefined): boolean =>
  normalizeRole(role) === 'admin';

export const isProjectManager = (role: string | null | undefined): boolean => {
  const normalizedRole = normalizeRole(role);
  return normalizedRole === 'project manager' || normalizedRole === 'project_manager';
};

export const isAdminOrProjectManager = (role: string | null | undefined): boolean =>
  isAdmin(role) || isProjectManager(role);
